import { motion } from 'framer-motion';

const bankPartners = [
  'ICICI Bank', 'HDFC Bank', 'Axis Bank', 'State Bank of India', 
  'Kotak Mahindra', 'Yes Bank', 'IndusInd Bank', 'Punjab National Bank'
];

export const WhyUsPartners = () => (
  <section className="py-24 bg-[#f8fafc]" data-testid="partners-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-center mb-12"
      >
        <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-[#0f172a] mb-4">
          Our Banking Partners
        </h2>
        <p className="text-[#64748b] max-w-2xl mx-auto">
          Strong relationships with leading financial institutions for better service.
        </p>
      </motion.div>

      <div className="flex flex-wrap justify-center gap-4">
        {bankPartners.map((bank, index) => (
          <motion.div
            key={bank}
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.3, delay: index * 0.05 }}
            className="px-6 py-3 bg-white rounded-full border border-slate-200 text-[#0f172a] text-sm font-medium shadow-sm"
          >
            {bank}
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
